import { render } from "./AllServicesAddedEmptyState.vue?vue&type=template&id=a1dcf0c2"
const script = {}

import exportComponent from "/home/forge/staging.hikeseo.co/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__